import React from "react"
import "./member.css"
import * as Moment from "moment"
import { Link } from "react-router-dom"
import styled from "styled-components"

import { ReactComponent as _EditIcon } from "../../assets/edit.svg";

const EditIcon = styled(_EditIcon)`
  width: 20px;
  height: 20px;

  color: #777;
  fill: currentColor;
  transition: all 200ms;

  div &:hover {
    transform: scale(1.3);
  }
`;



const MemeberWrap = styled.div`
  display: flex;
  flex-direction: row;
`

const MemberInfo = styled.div`
  flex: 1 1 100%;
`


const LinkWrap = styled(Link)`
  flex: 1 1 100%;
`

const DeleteMemberWrap = styled.div`
  /* flex: 1 1 auto; */
  padding: 3px 8px;
  margin: 5px;
  cursor: pointer;
  font-size: 0.6em;
  /* align-self: center; */
  color: #800;
  border: 1px solid #800;
  /* height: 100%; */
  display: flex;

  &:hover {
    background: #800;
    color: #fff;
  }
`

const DeleteBtn = styled.div`
  flex: 1 1 auto;
  align-self: center;


`

const Member = props => {
  const handleDeleteMember = () => {
    props.deleteMember(props.member.ID)
  }

  const currentRankImageUrl =
    props.memberRanks[0] && props.memberRanks[0].level
      ? "/" + props.memberRanks[0].level.LevelImage
      : null

  const currentRankImage =
    props.memberRanks[0] && props.memberRanks[0].level ? (
      <React.Fragment>
        <img className="rank-image" src={currentRankImageUrl} />
      </React.Fragment>
    ) : null

  const currentRank =
    props.memberRanks[0] && props.memberRanks[0].level ? (
      <div>
        {props.member.Title ? <span>{props.member.Title}, </span> : null}{" "}
        {/* <img className="rank" src={currentRankImageUrl} /> */}
        {props.memberRanks[0].level.LevelTitle},{" "}
        <span className="experience">{Moment(props.memberRanks[0].RankDate).fromNow()}</span>
      </div>
    ) : null

  const memberImage =
    props.member && props.member.ImageUrl ? (
      <div className="member-image-wrapper">
        <img className="image" src={props.member.ImageUrl} />
      </div>
    ) : null

  const memberRole = props.member.Role ? <div>{props.member.Role}</div> : null
  const memberExtraRole = props.member.ExtraRole ? <div>{props.member.ExtraRole}</div> : null

  // console.log("member id:", props.member.ID );
  const memberTagNew =
    props.member.Status && props.member.Status.toLowerCase() == "ny" ? (
      <div className="memberTag new">NY</div>
    ) : null
  const memberTagReady =
    props.member.Status && props.member.Status.toLowerCase() == "klar" ? (
      <div className="memberTag ready">KLAR</div>
    ) : null
  const deleteMember =
    (props.member.Status && props.member.Status.toLowerCase() == "ny") ||
    (props.member.Status && props.member.Status.toLowerCase() == "klar") || 
    props.member.TeamId == "99"  ? (
      <DeleteMemberWrap onClick={() => handleDeleteMember()}>
        <DeleteBtn >SLET</DeleteBtn>
      </DeleteMemberWrap>
    ) : null

  return (
    <MemeberWrap>
      <MemberInfo>
        <LinkWrap className="member" to={`/member/${props.member.ID}`}>
          {memberTagNew}
          {memberTagReady}
          <div className="member-rank">{currentRankImage}</div>
          {memberImage}
          <div className="member-info">
            <div className="member-linie">
              <div className="title">
                {props.member.FirstName}
                &nbsp;
                {props.member.LastName},{" "}
                {Moment().diff(Moment(props.member.Birthdate), "years", false)} år
              </div>
            </div>
            <div>{currentRank}</div>
            <div>
              {memberRole}
              {memberExtraRole}
              {props.member.TeamName}
            </div>
          </div>
          <Link className="editUser" to={`/edit/member/${props.member.ID}`}>
            <EditIcon />
          </Link>
        </LinkWrap>
      </MemberInfo>
      {deleteMember}
    </MemeberWrap>
  )
}

export default Member
